module.exports = __webpack_public_path__ + "static/media/logo.b2c5fc8a.svg";